var _rect, _rect2, _rect3, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgC2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65,
    rx: 32.5,
    fill: "#B8EBF5"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7.5,
    width: 51,
    height: 51,
    rx: 25.5,
    fill: "#FAFAFA",
    fillOpacity: 0.7
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7.5,
    width: 51,
    height: 51,
    rx: 25.5,
    stroke: "#FAFAFA"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.44 41.384V45H24.8V41.384L31.84 33.736C32.4373 33.096 32.8533 32.5093 33.088 31.976C33.344 31.4427 33.472 30.8773 33.472 30.28C33.472 29.576 33.2693 29.032 32.864 28.648C32.48 28.264 31.904 28.072 31.136 28.072C30.3253 28.072 29.3013 28.1573 28.064 28.328C26.848 28.4773 26.08 28.6053 25.76 28.712V25.352C26.592 25.1173 27.5413 24.936 28.608 24.808C29.6747 24.68 30.7413 24.616 31.808 24.616C33.5573 24.616 34.912 25.0747 35.872 25.992C36.832 26.888 37.312 28.1467 37.312 29.768C37.312 30.8347 37.1307 31.8053 36.768 32.68C36.4053 33.5333 35.7973 34.4187 34.944 35.336L29.344 41.384H37.44Z",
    fill: "#0B4F5D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgC2);
export default __webpack_public_path__ + "static/media/C2.d2ac9d87e4aa8621e78cc28f6dc5f802.svg";
export { ForwardRef as ReactComponent };